import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import PageLoader from "@/components/PageLoader.vue";

import Setting from "@/classes/Setting";

import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);

const item = ref(null);

// Methods
const indexSetting = () => {
    loader.value = true;

    Setting.indexSetting()
        .then((response: any) => {
            loader.value = false;

            item.value = response.data.reservationCapacity;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const headers: { text: string }[] = [
    { text: 'Label' },
];

onMounted( () => {
    indexSetting();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Settings" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DataTable, {
          headers: headers,
          count: 4
        }, {
          body: _withCtx(() => [
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5 w-11/12" }, [
                _createElementVNode("p", null, "Reservation Capacity Per Course")
              ], -1)),
              _createElementVNode("td", _hoisted_2, [
                (_ctx.$hasPermission('manage-settings'))
                  ? (_openBlock(), _createBlock(ActionButton, {
                      key: 0,
                      "edit-btn": "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/settings/edit/${item.value.id}`)))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})